(function (globalScope) {
  'use strict';

  var DEFAULTS = {
    // Only defer content that starts below this viewport multiplier.
    belowFoldMultiplier: 1.35,
    // Reveal after this delay once the user interacts (scroll/touch/mouse/key).
    revealDelayMs: 300,
    // Also reveal when close to viewport (prevents users seeing blank space).
    rootMargin: '800px 0px',
    // Reserve space to avoid CLS when content is deferred.
    containIntrinsicSize: '1px 900px',
    // Pick targets that are commonly heavy but visually "below fold".
    selectors: [
      '#insta-feed',
      '.instafeed',
      '.loox-reviews',
      '.loox-carousel',
      '.klaviyo-form',
      '.klaviyo-form-embed',
      '.predictive-search'
    ]
  };

  function assign(target) {
    target = target || {};
    for (var i = 1; i < arguments.length; i += 1) {
      var src = arguments[i] || {};
      for (var key in src) {
        if (Object.prototype.hasOwnProperty.call(src, key)) {
          target[key] = src[key];
        }
      }
    }
    return target;
  }

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function supportsContentVisibility() {
    return typeof CSS !== 'undefined' && CSS && typeof CSS.supports === 'function' && CSS.supports('content-visibility', 'hidden');
  }

  function getTop(node) {
    if (!node || typeof node.getBoundingClientRect !== 'function') return Number.MAX_SAFE_INTEGER;
    return node.getBoundingClientRect().top;
  }

  function markDeferred(el, options) {
    if (!el || el.__spbDeferred) return false;
    el.__spbDeferred = true;

    if (supportsContentVisibility() && el.style) {
      el.style.contentVisibility = 'hidden';
      el.style.containIntrinsicSize = options.containIntrinsicSize;
      // Avoid layout/paint cascades for large blocks.
      if (!el.style.contain) el.style.contain = 'paint style';
    } else if (el.style) {
      // Fallback: still reduces visual cost, but not as effective as content-visibility.
      el.style.visibility = 'hidden';
    }
    return true;
  }

  function reveal(el) {
    if (!el || el.__spbRevealed) return;
    el.__spbRevealed = true;
    if (el.style) {
      if (el.style.contentVisibility) el.style.contentVisibility = 'auto';
      if (el.style.visibility) el.style.visibility = '';
    }
  }

  function init(userOptions) {
    var options = assign({}, DEFAULTS, userOptions || {});
    var doc = options.document || (typeof document !== 'undefined' ? document : null);
    var win = options.window || (typeof window !== 'undefined' ? window : null);
    if (!doc || !win || typeof doc.querySelectorAll !== 'function') return { ok: false };

    var vh = Number(win.innerHeight || 0) || 800;
    var cutoff = vh * options.belowFoldMultiplier;

    var targets = [];
    (options.selectors || []).forEach(function (sel) {
      toArray(doc.querySelectorAll(sel)).forEach(function (el) {
        // Only defer things that start below the fold.
        if (getTop(el) > cutoff) targets.push(el);
      });
    });

    // Deduplicate
    var unique = [];
    var seen = new Set();
    targets.forEach(function (el) {
      if (seen.has(el)) return;
      seen.add(el);
      unique.push(el);
    });

    unique.forEach(function (el) { markDeferred(el, options); });

    var revealedByInteraction = false;
    var revealTimer = null;

    function scheduleRevealAll() {
      if (revealedByInteraction) return;
      revealedByInteraction = true;
      if (revealTimer) return;
      revealTimer = win.setTimeout(function () {
        unique.forEach(reveal);
      }, options.revealDelayMs);
    }

    ['scroll', 'touchstart', 'mousemove', 'keydown', 'pointerdown'].forEach(function (evt) {
      win.addEventListener(evt, scheduleRevealAll, { passive: true, once: true });
    });

    // Reveal when close to viewport.
    var IO = typeof win.IntersectionObserver === 'function' ? win.IntersectionObserver : (typeof IntersectionObserver === 'function' ? IntersectionObserver : null);
    if (typeof IO === 'function') {
      var io = new IO(function (entries) {
        entries.forEach(function (entry) {
          if (entry && (entry.isIntersecting || entry.intersectionRatio > 0)) {
            reveal(entry.target);
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: options.rootMargin });

      unique.forEach(function (el) { io.observe(el); });
      return { ok: true, deferred: unique.length, observer: io };
    }

    return { ok: true, deferred: unique.length };
  }

  var api = { init: init };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (globalScope) globalScope.ShopifyDeferSections = api;

  if (typeof document !== 'undefined') {
    var config = (globalScope && globalScope.ShopifyDeferSectionsConfig) ? globalScope.ShopifyDeferSectionsConfig : null;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(config || {}); });
    } else {
      init(config || {});
    }
  }
})(typeof window !== 'undefined' ? window : globalThis);
